module.exports = __webpack_public_path__ + "static/img/iphone.1f63b4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/iphone.png
// module id = qgzy
// module chunks = 9